module.exports = __webpack_public_path__ + "img/yntl.864a541b.jpg";